import Vue from 'vue'

const deviceUtils = {
  data () {
    return {
      modificationsRequested: [],
      dragEnterDesktopTimeoutPointer: null,
      dragEnterDesktopTimeoutMs: 300,
      desktopsScreenShotsRequested: [],
      sendingOnDemandScheduleRequestToDevice: false,
      sendingOnDemandScheduleRequestsToGroup: false
    }
  },
  methods: {
    async toggleDesktopSelected (desktop, $event, desktops = []) {
      if (!$event.shiftKey) {
        if (!$event.ctrlKey && !$event.metaKey) {
          await this.$store.dispatch('Device/addDesktopsSelectedRight', [desktop])
          if (this.$refs.RightClickDesktopMenu) this.$refs.RightClickDesktopMenu.closeRightClickMenu()
          return
        }
        this.$store.dispatch('Device/toggleDesktopSelectedRight', desktop)
      }
      if ($event.shiftKey) {
        if (!$event.ctrlKey && !$event.metaKey) {
          const desktopClickedIndex = desktops.findIndex(d => d.id === desktop.id)
          const previouslySelectedDesktopIndex = desktops.findIndex(d => d.id === this.$store.state.Device.desktops_selected_right[this.$store.state.Device.desktops_selected_right.length - 1].id)
          const startIndex = previouslySelectedDesktopIndex < desktopClickedIndex ? previouslySelectedDesktopIndex : desktopClickedIndex
          const endIndex = previouslySelectedDesktopIndex < desktopClickedIndex ? desktopClickedIndex : previouslySelectedDesktopIndex
          await this.$store.dispatch('Device/addDesktopsSelectedRight', desktops.slice(startIndex, endIndex + 1))
        } else {
          console.log('TODO - Shift-shrink devices selection shift + ctrl')
        }
      }
      if (this.$store.state.Device.desktops_selected_right.length === 1) {
        this.closeRightClickMenu()
      }
    },
    async toggleDesktopGroupSelected (desktopgroup, $event) {
      if (!$event.shiftKey) {
        if (!$event.ctrlKey && !$event.metaKey) {
          await this.$store.dispatch('Device/clearDesktopsSelectedRight')
          await this.$store.dispatch('Device/clearDesktopGroupsSelectedRight')
          await this.$store.dispatch('Device/addDesktopGroupsSelectedRight', [desktopgroup])
          if (this.$refs.RightClickDesktopGroupMenu) this.$refs.RightClickDesktopGroupMenu.closeRightClickMenu()
          return
        }
        this.$store.dispatch('Device/toggleDesktopGroupsSelectedRight', desktopgroup)
      }
    },
    modificationExists (desktop) {
      return this.$store.state.Device.desktops_affected.findIndex(da => da.Medium.id === desktop.LocalPlayList) > -1
    },
    async sendContentUpdateRequest (desktop, $event) {
      if ($event && ($event.ctrlKey || $event.metaKey)) {
        this.toggleDesktopSelected(desktop, $event)
        return
      }
      const modification = this.$store.state.Device.desktops_affected.find(da => da.Medium.id === desktop.LocalPlayList)
      if (!modification || this.modificationsRequested.includes(desktop.id)) return
      this.modificationsRequested.push(desktop.id)
      await Vue.axios
        .post('devicedesktop/prepareContentsAndSendRequestToDevice', { 'ModificationId': modification.id })
      this.modificationsRequested.splice(this.modificationExists(desktop), 1)
    },
    async updateScreenshotSendRequestToDevice (desktop, $event) {
      if ($event && ($event.ctrlKey || $event.metaKey)) {
        this.toggleDesktopSelected(desktop, $event)
        return
      }
      this.desktopsScreenShotsRequested.push(desktop)
      await Vue.axios
        .post('/deviceDesktop/updateScreenshotSendRequestToDevice', {
          desktopId: desktop.id
        })
    },
    desktopIsSelected (desktop) {
      return (
        this.$store.state.Device.desktops_selected_right.findIndex(
          ds => ds.id === desktop.id
        ) > -1
      )
    },
    dragEnterDesktop (desktop, $event) {
    // clearTimeout(this.dragEnterDesktopTimeoutPointer)
    // this.dragEnterDesktopTimeoutPointer = setTimeout(() => {
      this.$store.dispatch('Device/clearDesktopsSelectedRight')
      this.$store.dispatch('Device/addDesktopsSelectedRight', [desktop])
    // }, this.dragEnterDesktopTimeoutMs)
    },
    async sendRequest (desktopId, method, args) {
      let responseData
      await Vue.axios
        .post(
          'DeviceDesktop/sendRequest',
          {
            desktopId: desktopId,
            method,
            args
          }
        )
        .then(response => {
          responseData = response.data
        })
      return responseData
    },
    getScreenShotURI (desktop) {
      const uri = desktop.deviceDesktopScreenShotFilename
      return uri
    },
    getGroupFromDesktop (desktop) {
      if (!desktop) return
      return this.$store.state.Device.device_desktop_groups.find(dg => dg.id === desktop.DeviceDesktopGroup)
    },
    getDeviceFromDesktop (desktop) {
      if (!desktop) return
      if (typeof desktop.Device === 'object' && desktop.Device.id) {
        return desktop.Device
      }
      return this.$store.state.Device.device_list.find(d => d.id === desktop.Device)
    },
    desktopHasSchedule (desktop) {
      const desktopGroup = this.getGroupFromDesktop(desktop)
      const device = this.getDeviceFromDesktop(desktop)
      if (!device) return false
      return device.Device_DaytimeRestrictions.length > 0 ||
        device.Device_DateRestrictions.length > 0 ||
        device.HolidaySets.length > 0 ||
        (desktopGroup && (
          desktopGroup.DeviceDesktopGroup_DateRestrictions.length > 0 ||
          desktopGroup.DeviceDesktopGroup_DaytimeRestrictions.length > 0 ||
          desktopGroup.HolidaySets.length > 0
        ))
    },
    async sendOnDemandScheduleRequest (sendToGroup = false, item) {
      if (sendToGroup) {
        console.log(item)
        this.sendingOnDemandScheduleRequestsToGroup = true
        for (const deviceDesktop of item.DeviceDesktops) {
          await this.sendRequest(deviceDesktop.id, 'updateSchedule', {})
        }
      } else {
        this.sendingOnDemandScheduleRequestToDevice = true
        await this.sendRequest(item.DeviceDesktops[0].id, 'updateSchedule', {})
      }
      this.$emit('requestSent')
      this.sendingOnDemandScheduleRequestToDevice = false
      this.sendingOnDemandScheduleRequestsToGroup = false
    },
    contentDownload (desktop) {
      if (!desktop) return
      const desktopDownloads = this.$store.state.Device.content_downloads
        .filter(cd => cd.ContentDownloadDeviceDesktop === desktop.id)
      return desktopDownloads[desktopDownloads.length - 1]
    }
  },
  computed: {
  }
}
export default deviceUtils



// WEBPACK FOOTER //
// ./src/components/Common/deviceUtils.mixin.js